import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { HashRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { ToastContainer, toast } from 'react-toastify';
import RootReducer from './services/state-management/reducers/RootReducer';
import Routes from './routes/routes';
import ErrorBoundary from './components/ErrorBoundary';
import * as serviceWorker from './serviceWorker';

const store = createStore(RootReducer, compose(applyMiddleware(thunk)));

window.addEventListener('unhandledrejection', (event) => {
  event.preventDefault();
  toast.error('Something went wrong. Please try again.');
});

ReactDOM.render(
  <Provider store={store}>
    <ErrorBoundary fallback={
      <div style={{ padding: '2rem', textAlign: 'center' }}>
        <h3>Something went wrong.</h3>
        <p>Please refresh the page. If the problem persists, contact support.</p>
        <button onClick={() => window.location.reload()} style={{ marginTop: '1rem', padding: '0.5rem 1.5rem' }}>
          Refresh
        </button>
      </div>
    }>
      <HashRouter>
        <Routes />
      </HashRouter>
    </ErrorBoundary>
    <ToastContainer />
  </Provider>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
